import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-portal-rt_menu_shopping_fill",
  "use": "rt-portal-rt_menu_shopping_fill-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-portal-rt_menu_shopping_fill\">\n<g>\n\t<path d=\"M935.3,229.8c-9.6-10.9-23.5-17.2-38-17.2l-622.9-0.2c-4.3,0-7.9-3.2-8.5-7.4l-12.8-93.3c-3.7-26.8-26.9-47.2-54-47.3\n\t\tL103.3,64h-0.1c-15,0-27.1,12.1-27.2,27v6.8c-0.1,15,12,27.2,27,27.3l90.4,0.4L265,648.3c1.2,45.2,38.4,81.5,83.8,81.5h465.9\n\t\tc45.5,0,82.7-36.4,83.8-81.6l49-378.5C949.4,255.3,944.9,240.7,935.3,229.8z\" />\n\t<circle cx=\"384.7\" cy=\"870.3\" r=\"89.8\" />\n\t<circle cx=\"787.6\" cy=\"870.3\" r=\"89.8\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/rt_menu_shopping_fill.svg
// module id = 1291
// module chunks = 116